import { delayedCall, dispatcher, IEvent, ingenuity } from "@quest/base-core";
import {
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
  WinPresentationController,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";

/**
 * WinPresentationControllerGame class handels the winpresentation for base game.
 * it controls the win frames, symbol animation presentation.
 */
export class WinPresentationControllerGame extends WinPresentationController {
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.ON_START_BONUS_PRESENTATION, this.onStartBonusPresentation, this);
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.ON_START_BONUS_PRESENTATION, this.onStartBonusPresentation, this);
  }

  /**
   * This method fire an event to start the bonus symbols
   * triggering animation on reel when Hold And Re-Spin Feature triggered.
   */
  private onStartBonusPresentation(): void {
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD);
    (ingenuity.soundManager as any).stop(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.BONUS_SYMBOL_TRIGGERING_ANIM_SOUND,
      1,
      false,
      SlotConstantsBehavior.SOUND_LIST_PRELOAD
    );
    dispatcher.fireEvent(eventDispatchers.START_BONUS_WIN_ANIM, (ingenuity.parserModel as GameParserModel).getBonusTriggeringOffset());
  }

  /**
   * overide to add 'hold and respin' condition to code
   * @param evt 
   */
  protected onShowAllFrames(evt: IEvent): void {
    (ingenuity.parserModel as GameParserModel).getIsWildWin() &&
      (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_WIN_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    (ingenuity.parserModel as GameParserModel).setIsWildWin(false);
    this.playStackAnimation();
    // to-do: write code here to show win frames on spaghtti
    const windata = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASEGAME_WIN_ALPHA, windata);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA_ON_SYMBOL, windata);
    if (this.paylineView) {
      if (
        this.model.getIsAutoPlayLeft() &&
        !this.model.getIsBigWin() &&
        !(ingenuity.parserModel as GameParserModel).getHasFreeGamesWin() &&
        !(ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus()
      ) {
        dispatcher.fireEvent(SlotEventConstants.SHOW_ALL_FRAMES, {
          callback() {
            //
          },
          callbackScope: this,
          delayTimer: this.model.getDelayForSpaghttiDispaly(),
          winData: windata,
          display: true,
        });
      } else if ((ingenuity.parserModel as GameParserModel).getHasLineWins()) {
        this.onShowAllFramesComplete();
      } else if (this.model.getIsScatterWins()) {
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      }
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
    if (ingenuity.configData.playAllSymbolAnim) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
    // Play all anim with delay to show stack before static hide.
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresent() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0
    ) {
      delayedCall(
        SlotConstantsBehavior.PLAY_ANIM_DELAY_FOR_STACK,
        SlotConstantsBehavior.DURATION_100,
        () => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
        },
        this
      );
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
    }
  }
}
